export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_320.1da4145a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};